import React from 'react';

import Left from '@material-ui/icons/ChevronLeftRounded';

import Button from '../../../../components/Button';
import { IArrowProps } from './ArrowRight';

export const ArrowLeft = ({ onClick }: IArrowProps) => (
  <Button variant="text" className="arrow-left" onClick={onClick}>
    <Left color="primary" fontSize="large" />
  </Button>
);
